import React from 'react';
import PropTypes from 'prop-types';

class MenuItemCategory extends React.Component {
  constructor(props) {
    super(props);
    this.state = { isOpen: false };
    this.toggle = this.toggle.bind(this);
  }
  toggle() {
    this.setState({ isOpen: !this.state.isOpen });
    if (this.props.onDisclose) {
      this.props.onDisclose(this.state);
    }
  }
  render() {
    return (
      <div className="menuCategory">
        <button className="menuCategory__titleWrapper" onClick={this.toggle}>
          <h4 className="menuCategory__title">
            {this.props.name}
          </h4>
          {this.state.isOpen ?
            <i className="bi_interface-top menuCategory__icn" /> :
            <i className="bi_interface-bottom menuCategory__icn" />
          }
        </button>
        {this.state.isOpen &&
          <div className="menuCategory__content">
            {this.props.children}
          </div>
        }
      </div>
    );
  }
}

MenuItemCategory.propTypes = {
  name: PropTypes.string.isRequired,
  onDisclose: PropTypes.func,
};

export default MenuItemCategory;



// WEBPACK FOOTER //
// ./src/components/menu/menu-item-category.js